import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { FULL_ROLE_AGENT } from '@utils/helpers'
import { ROLE } from '@utils/constant'

const notificationAgentAdminRoutes = {
  path: 'notification_agentadmin',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.notificationAgent.list'),
  },
  children: [
    {
      path: '',
      name: 'notificationAgentAdmin',
      component: () =>
        lazyLoadView(import('@views/NotificationAgentAdmin/list.vue')),
      meta: {
        authRequired: FULL_ROLE_AGENT,
      },
    },
    {
      path: 'registration',
      name: 'notificationAgentAdminRegistration',
      component: () =>
        lazyLoadView(import('@views/NotificationAgentAdmin/add-new.vue')),
      meta: {
        authRequired: [ROLE.AGENT_ADMIN, ROLE.AGENT_SUB, ROLE.AGENT_ANNOUNCE],
        label: i18n.t('router.notificationAgent.add'),
      },
    },
    {
      path: ':id',
      name: 'notificationAgentAdminDetail',
      component: () =>
        lazyLoadView(import('@views/NotificationAgentAdmin/details.vue')),
      meta: {
        authRequired: FULL_ROLE_AGENT,
        label: i18n.t('router.notificationAgent.details'),
      },
    },
  ],
}

export default notificationAgentAdminRoutes
